export default "__VITE_ASSET__DuWdwS_k__"